<!-- =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <div id="page-user-view">
    <!--<vs-alert
      color="danger"
      title="User Not Found"
      :active.sync="user_not_found"
    >
      <span>User record with id: {{ $store.state.AppActiveUser.userId }} not found. </span>
      <span>
        <span>Check </span
        ><router-link
          :to="{ name: 'page-user-list' }"
          class="text-inherit underline"
          >All Users</router-link
        >
      </span>
    </vs-alert>-->

    <div id="user-data" v-if="user_data">
      <vx-card title="Account" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
              <img :src="user_data.avatar" class="rounded w-full" />
            </div>
          </div>

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">{{ $t("profile.p1") }}</td>
                <td>{{ user_data.username }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t("profile.p2") }}</td>
                <td>{{ user_data.firstName }} {{ user_data.lastName }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t("profile.p3") }}</td>
                <td>{{ user_data.email }}</td>
              </tr>
              <!--<tr>
                <td class="font-semibold">Email</td>
                <td>{{ user_data.email }}</td>
              </tr>-->
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">{{ $t("profile.p4") }}</td>
                <td><vs-chip :color="chipColor(user_data.status)">
                  <span>{{ user_data.status }}</span>
                </vs-chip></td>
              </tr>
              <!--<tr>
                <td class="font-semibold">User Type</td>
                <td>{{ user_data.user_type }}</td>
              </tr>-->
              <tr>
                <td class="font-semibold">{{ $t("profile.p5") }}</td>
                <td>{{ user_data.company[0].name }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              :to="{
                name: 'admin-user-edit'
              }"
              >{{ $t("profile.p6") }}</vs-button
            >
            <!--<vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              @click="confirmDeactivateRecord"
              >Deactivate Account</vs-button
            >-->
          </div>
        </div>
      </vx-card>

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Information" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">{{ $t("profile.p7") }}</td>
                <td>{{ formatDate(user_data.dob) }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t("profile.p8") }}</td>
                <td>{{ user_data.mobile }}</td>
              </tr>
              <!--<tr>
                <td class="font-semibold">Website</td>
                <td>{{ user_data.website }}</td>
              </tr>-->
              <!--<tr>
                <td class="font-semibold">Languages</td>
                <td>{{ user_data.languages_known.join(", ") }}</td>
              </tr>-->
              <tr>
                <td class="font-semibold">{{ $t("profile.p9") }}</td>
                <td>{{ user_data.gender }}</td>
              </tr>
              <!--<tr>
                <td class="font-semibold">Contact</td>
                <td>{{ user_data.contact_options.join(", ") }}</td>
              </tr>-->
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Address" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">{{ $t("profile.p10") }}</td>
                <td>{{ user_data.addLine1 }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t("profile.p11") }}</td>
                <td>{{ user_data.addLine2 }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t("profile.p12") }}</td>
                <td>{{ user_data.city }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t("profile.p13") }}</td>
                <td>{{ user_data.state }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t("profile.p14") }}</td>
                <td>{{ user_data.country }}</td>
              </tr>
              <!--<tr>
                <td class="font-semibold">Slack</td>
                <td>{{ user_data.social_links.slack }}</td>
              </tr>-->
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="$t('socialLink')" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">{{ $t("profile.p15") }}</td>
                <td>{{ user_data.twitter }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t("profile.p16") }}</td>
                <td>{{ user_data.facebook }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t("profile.p17") }}</td>
                <td>{{ user_data.instagram }}</td>
              </tr>
              <tr>
                <td class="font-semibold">{{ $t("profile.p18") }}</td>
                <td>{{ user_data.linkedin }}</td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>

      <!-- Permissions -->
      <!--<vx-card>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="flex items-end px-3">
              <feather-icon svgClasses="w-6 h-6" icon="LockIcon" class="mr-2" />
              <span class="font-medium text-lg leading-none">Permissions</span>
            </div>
            <vs-divider />
          </div>
        </div>

        <div class="block overflow-x-auto">
          <table class="w-full permissions-table">
            <tr>
              &lt;!&ndash;
                You can also use `Object.keys(Object.values(data_local.permissions)[0])` this logic if you consider,
                our data structure. You just have to loop over above variable to get table headers.
                Below we made it simple. So, everyone can understand.
               &ndash;&gt;
              <th
                class="font-semibold text-base text-left px-3 py-2"
                v-for="heading in [
                  'Module',
                  'Read',
                  'Write',
                  'Create',
                  'Delete'
                ]"
                :key="heading"
              >
                {{ heading }}
              </th>
            </tr>

            <tr v-for="(val, name) in user_data.permissions" :key="name">
              <td class="px-3 py-2">{{ name }}</td>
              <td
                v-for="(permission, name) in val"
                class="px-3 py-2"
                :key="name + permission"
              >
                <vs-checkbox v-model="val[name]" class="pointer-events-none" />
              </td>
            </tr>
          </table>
        </div>
      </vx-card>-->
    </div>
  </div>
</template>

<script>
// import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";
import i18n from "@/i18n/i18n";
export default {
  data() {
    return {
      user_data: null,
      user_not_found: false,
      userType: this.$store.state.AppActiveUser.userType
    };
  },
  computed: {
    chipColor () {
      return (value) => {
        if (value === 'active') return 'success'
        else if (value === 'blocked') return 'danger'
        else if (value === 'deactivated') return 'warning'
        else return 'primary'
      }
    },
    userAddress() {
      let str = "";
      for (const field in this.user_data.location) {
        str += `${field} `;
      }
      return str;
    }
  },
  methods: {
    formatDate(sentDate) {
      let date = new Date(sentDate)
      console.log("sent date", date);
      date = `${date.getFullYear()  }-${  date.getMonth() + 1  }-${  date.getDate()}`;
      return date;
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: i18n.t('notification.admin.user.deleted.warning.w1'),
        text: i18n.t('notification.admin.user.deleted.warning.w2',{ username: this.user_data.username}),
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      // this.$router.push({ name: "admin-user-list" });
      this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting user */
      this.$store
        .dispatch("userManagement/removeRecord", this.user_data.id)
        .then(() => {
          this.$router.push({ name: "admin-user-list" });
          this.showDeleteSuccess();
        })
        .catch(err => {
          console.error(err);
        });
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: i18n.t('notification.admin.user.deleted.success.a1'),
        text:  i18n.t('notification.admin.user.deleted.success.a2')
      });
    }
  },
  created() {
    // Register Module UserManagement Module
    /*if (!moduleUserManagement.isRegistered) {
        this.$store.registerModule("userManagement", moduleUserManagement);
        moduleUserManagement.isRegistered = true;
      }*/

    const usersId = this.$route.params.usersId;
    // const userType = this.$store.state.AppActiveUser.userType;
    this.$store
      .dispatch("userManagement/fetchUser", usersId)
      .then(res => {
        this.user_data = res;
        console.log("user data view", this.user_data)
      })
      .catch(err => {
        if (err.response.status === 404) {
          this.user_not_found = true;
          return;
        }
        console.error(err);
      });
  }
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
